<template>
  <section class="p-2">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Partner Utilities</div>
        <div>
          <bread-crumb :bread-crumbs="['Partner Utilities']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>

      <v-tabs v-model="usertype">
        <v-tab
          v-for="item in items"
          :key="item.key"
          :href="'#' + item.key"
          class="text-capitalize text-decoration-none"
        >
          {{ item.label }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="usertype">
        <!-- <v-tab-item id="apiPartner"> <ApiPartnerVue /> </v-tab-item> -->
        <v-tab-item id="apiStatus"> <ApiStatusVue /> </v-tab-item>
        <!-- <v-tab-item id="payoutAgent"> <PayoutAgentVue /> </v-tab-item> -->
        <v-tab-item id="apiBalance"> <ApiBalanceVue /> </v-tab-item>
      </v-tabs-items>
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
// import ApiPartnerVue from "./utilityTabs/ApiPartner.vue";
import ApiStatusVue from "./utilityTabs/ApiStatus.vue";
// import PayoutAgentVue from "./utilityTabs/PayoutAgent.vue";
import ApiBalanceVue from "./utilityTabs/ApiBalance.vue";
export default {
  name: "Partner Utilities",
  data: () => {
    return {
      usertype: "individual",
      items: [
        { label: "API Status", key: "apiStatus" },
        { label: "API Balance", key: "apiBalance" },
        { label: "API Partner", key: "apiPartner" },
        // { label: "Change Payout Agent", key: "payoutAgent" },
      ],
    };
  },
  components: {
    BreadCrumb,
    // ApiPartnerVue,
    ApiStatusVue,
    // PayoutAgentVue,
    ApiBalanceVue,
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
</style>
